import { z } from 'zod/mini'

import { gtmMetadataShape } from './gtm-metadata'
import { itemSchema } from './item'
import { nonEmptyString } from './non-empty-string'

export const viewItemListSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('view_item_list'),
  ecommerce: z.strictObject({
    currency: nonEmptyString(),
    item_list_id: nonEmptyString(),
    item_list_name: nonEmptyString(),
    items: z
      .array(
        z.strictObject({
          ...itemSchema.shape,
          item_list_id: nonEmptyString(),
          item_list_name: nonEmptyString(),
        }),
      )
      .check(z.minLength(1)),
  }),
})
